import { LoadingIndicator } from 'components/LoadingIndicator';
import { Page } from 'components/Page/Page';
import { Form } from 'components/form/Form';
import { Formik } from 'formik';
import i18n from 'i18n';
import { useCallback } from 'react';
import { ECSegmentFormModel } from './ECSegmentFormModel';
import { ECSegmentFormContent } from './ECSegmentFormContent';
import { Button } from 'react-bootstrap';
import { CopyableOverlayTrigger } from 'components/CopyableOverlayTrigger/CopyableOverlayTrigger';
import { Redirect } from 'react-router-dom';
import { Modal } from 'components/Modal/Modal';

export type ECSegmentFormProps = {
  useModel: () => ECSegmentFormModel;
};

export const ECSegmentForm: React.FC<ECSegmentFormProps> = ({
  useModel
}) => {

  const {
    loading,
    modalData,
    redirectPath,
    canAddSegment,
    defaultECSegment,
    save,
    useFields
  } = useModel();

  const renderFormBtns = useCallback(() => (
    <>
      {
        canAddSegment
          ? <Form.SubmitButton />
          : (
            <CopyableOverlayTrigger
              placement='top'
              trigger='hover'
              overlay={i18n.t<string>('ecSegmentList.hints.cannotCreate')}
            >
              <Button type='submit' size='sm' disabled>
                {i18n.t<string>('common.buttons.submit')}
              </Button>
            </CopyableOverlayTrigger>
          )
      }
      <Form.CancelButton />
    </>
  ), [canAddSegment]);

  if (!defaultECSegment) {
    return <LoadingIndicator />;
  }

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return (
    <Page title={i18n.t<string>('ecSegmentForm.titles.setup')}>
      {loading && <LoadingIndicator />}
      {modalData && (
        <Modal
          title={modalData.title}
          secondaryButton={{
            title: i18n.t<string>('common.buttons.submit'),
            callback: modalData.onConfirm
          }}
        >
          {modalData.message}
        </Modal>
      )}
      <Formik
        initialValues={defaultECSegment}
        enableReinitialize
        onSubmit={save}
        validateOnBlur={false}
      >
        {(formikProps) => (
          <Form formikProps={formikProps} renderFormBtns={renderFormBtns}>
            <ECSegmentFormContent useFields={useFields} />
          </Form>
        )}
      </Formik>
    </Page>
  );
};
